import d3 from 'd3';

class TreeController {
  constructor($scope, $element, rx, LayoutService) {
    this.$element = $element;
    this.LayoutService = LayoutService;
    this.renderDebounce = 100;

    let subscriptions = [
      rx.Observable.merge(
        rx.Observable.merge(
          $scope.$eventToObservable('resize'),
          $scope.$eventToObservable('splitterChanged'),
          $scope.$toObservable('$ctrl.aggregate'),
        ),
          //.debounce(this.renderDebounce),
        $scope.$eventToObservable('beforePrint'),
        $scope.$eventToObservable('afterPrint'),
        $scope.$eventToObservable('init'),
      )
        .subscribe((e) => {
          // console.log(e);
          this.render();
        }),
    ];

    $scope.$on('$destroy', () => subscriptions.forEach((subscription) =>
      subscription.dispose()));
  }

  getRoot() {

    let rows = this.aggregate.cells.map((cell) => {
      return this.aggregate.filter.drilldown.map((dd) => this.model.getCellLabel(
        dd,
        cell,
      ));
    });

    // console.log("ROWS", rows);

    let children = this.aggregate.cells.map((cell) => {
      return {
        'name': this.model.getCellLabel(
          this.aggregate.filter.drilldown[0],
          cell,
        ),
      };
    });

    let root = {'name': gettext('Все события'), 'children': []};

    let updateTree = (node, row) => {
      if (!row[0]) return;
      let child = node.children.find((child) => child.name === row[0]);
      if (!child) {
        child = {'name': row[0], 'children': []};
        node.children.push(child);
      }
      updateTree(child, row.splice(1));
    };

    rows.forEach((row) => updateTree(root, row));

    //console.log("ROOT", root);

    function collapse(d) {
      if (d.children) {
        d._children = d.children;
        d._children.forEach(collapse);
        d.children = null;
      }
    }

    //root.children.forEach(collapse);
    return root;
  }

  render() {

    let aggregate = this.aggregate;

    //console.log("TREE", aggregate);

    this.$element.find('svg').remove();

    if (!aggregate || !this.aggregate.filter) {
      return;
    }

    const animate = !this.LayoutService.isPrint;
    let profileChart = this.$element[0];
    let width = this.$element.width();
    let height = this.$element.height();

    let root = this.getRoot(aggregate, this.aggregate.filter);

    root.x0 = height / 2;
    root.y0 = 0;

    let margin = {'left': 100, 'top': 0};

    let i = 0;
    const duration = 750;

    let tree = d3.layout.tree()
      .size([height, width]);

    let diagonal = d3.svg.diagonal()
      .projection(function (d) {
        return [d.y, d.x];
      });

    let svg = d3.select(profileChart).append('svg')
      .attr('width', width)
      .attr('height', height)
      .append('g')
      .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

    //d3.select(self.frameElement).style("height", "800px");

    let update = (source) => {

      // Compute the new tree layout.
      let nodes = tree.nodes(root).reverse();
      let links = tree.links(nodes);

      // Normalize for fixed-depth.
      nodes.forEach(d => {
        d.y = d.depth * 180;
      });

      // Update the nodes…
      let node = svg.selectAll('g.node')
        .data(nodes, d => d.id || (d.id = ++i));

      if (animate) {
        // Enter any new nodes at the parent's previous position.
        let nodeEnter = node.enter().append('g')
          .attr('class', 'node')
          .attr(
            'transform',
            d => 'translate(' + source.y0 + ',' + source.x0 + ')',
          )
          .on('click', click);

        nodeEnter.append('circle')
          .attr('r', 1e-6)
          .style('fill', d => d._children ? 'lightsteelblue' : '#fff');

        nodeEnter.append('text')
          .attr('x', function (d) {
            return d.children || d._children ? -10 : 10;
          })
          .attr('dy', '.35em')
          .attr('text-anchor', d => d.children || d._children ? 'end' : 'start')
          .text(d => d.name)
          .style('fill-opacity', 1e-6);

        // Transition nodes to their new position.
        let nodeUpdate = node.transition()
          .duration(duration)
          .attr('transform', d => 'translate(' + d.y + ',' + d.x + ')');

        nodeUpdate.select('circle')
          .attr('r', 4.5)
          .style('fill', d => d._children ? 'lightsteelblue' : '#fff');

        nodeUpdate.select('text')
          .style('fill-opacity', 1);

        // Transition exiting nodes to the parent's new position.
        let nodeExit = node.exit().transition()
          .duration(duration)
          .attr(
            'transform',
            d => 'translate(' + source.y + ',' + source.x + ')',
          )
          .remove();

        nodeExit.select('circle')
          .attr('r', 1e-6);

        nodeExit.select('text')
          .style('fill-opacity', 1e-6);
      } else {
        // Enter any new nodes at the parent's previous position.
        let nodeEnter = node.enter().append('g')
          .attr('class', 'node')
          .attr('transform', d => 'translate(' + d.y + ',' + d.x + ')')
          .on('click', click);

        nodeEnter.append('circle')
          .attr('r', 4.5)
          .style('fill', d => d._children ? 'lightsteelblue' : '#fff');

        nodeEnter.append('text')
          .attr('x', d => d.children || d._children ? -10 : 10)
          .attr('dy', '.35em')
          .attr('text-anchor', d => d.children || d._children ? 'end' : 'start')
          .text(d => d.name)
          .style('fill-opacity', 1);
      }

      // Update the links…
      let link = svg.selectAll('path.node-link')
        .data(links, d => d.target.id);

      if (animate) {
        // Enter any new links at the parent's previous position.
        link.enter().insert('path', 'g')
          .attr('class', 'node-link')
          .attr('d', d => {
            let o = {x: source.x0, y: source.y0};
            return diagonal({source: o, target: o});
          });

        // Transition links to their new position.
        link.transition()
          .duration(duration)
          .attr('d', diagonal);

        // Transition exiting nodes to the parent's new position.
        link.exit().transition()
          .duration(duration)
          .attr('d', d => {
            let o = {x: source.x, y: source.y};
            return diagonal({source: o, target: o});
          })
          .remove();
      } else {
        // Enter any new links at the parent's previous position.
        link.enter().insert('path', 'g')
          .attr('class', 'node-link')
          .attr('d', d => diagonal({
            source: {x: d.source.x, y: d.source.y},
            target: {x: d.target.x, y: d.target.y},
          }));
      }

      // Stash the old positions for transition.
      nodes.forEach(d => {
        d.x0 = d.x;
        d.y0 = d.y;
      });
    };

    function updateFast(source) {

      // Compute the new tree layout.
      let nodes = tree.nodes(root).reverse();
      let links = tree.links(nodes);

      // Normalize for fixed-depth.
      nodes.forEach(d => {
        d.y = d.depth * 180;
      });

      // Update the nodes…
      let node = svg.selectAll('g.node')
        .data(nodes, d => d.id || (d.id = ++i));
      // Enter any new nodes at the parent's previous position.
      let nodeEnter = node.enter().append('g')
        .attr('class', 'node')
        .attr('transform', d => 'translate(' + d.y + ',' + d.x + ')')
        .on('click', click);

      nodeEnter.append('circle')
        .attr('r', 4.5)
        .style('fill', d => d._children ? 'lightsteelblue' : '#fff');

      nodeEnter.append('text')
        .attr('x', d => d.children || d._children ? -10 : 10)
        .attr('dy', '.35em')
        .attr('text-anchor', d => d.children || d._children ? 'end' : 'start')
        .text(d => d.name)
        .style('fill-opacity', 1);

      // Update the links…
      let link = svg.selectAll('path.node-link')
        .data(links, d => d.target.id);

      // Enter any new links at the parent's previous position.
      link.enter().insert('path', 'g')
        .attr('class', 'node-link')
        .attr('d', d => {
          return diagonal({
            source: {x: d.source.x, y: d.source.y},
            target: {x: d.target.x, y: d.target.y},
          });
        });
    }

    // Toggle children on click.
    function click(d) {
      if (d.children) {
        d._children = d.children;
        d.children = null;
      } else {
        d.children = d._children;
        d._children = null;
      }
      update(d);
    }

    update(root);
  }
}

export const TreeComponent = {
  template  : '',
  bindings  : {
    model    : '<',
    aggregate: '<',
  },
  controller: TreeController,
};



// WEBPACK FOOTER //
// ./src/stat/tree.component.js